import React from 'react';
import { Container } from 'react-bootstrap';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import AppFooter from './components/AppFooter';
import AppNavbar from './components/AppNavbar';
import Cotizador from './pages/Cotizador';
import Home from './pages/Home';

function App() {
  return (
    <Router>
      <div className="min-vh-100 d-flex flex-column" style={{backgroundColor: 'var(--color-background)'}}>
        <AppNavbar />
        <Container fluid className="px-0 flex-grow-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/cotizador/:id" element={<Cotizador />} />
          </Routes>
        </Container>
        <AppFooter />
      </div>
    </Router>
  );
}

export default App;
